import { Group, Layout, Page } from "@/comn/components";
import { useNavigate } from "react-router-dom";
import { comnUtils } from "@/comn/utils";
import { useFetch, useForm, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { APIS, URLS, SF_SCTN_INFO } from "@/tra/tancis/ptli/usr/sctn/services/PtliSctnService";
import { formatText } from "@/comn/components/_";
import { useEffect, useState } from "react";

/*
 * Section Registration
 * !== 섹션 등록 ==!
 */
export const PTLI0918002S = () => {
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "PTL0021" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const navigate = useNavigate();
    const { pgeStore } = useStore({ pgeUid: pgeUid });
    const modal = useModal();
    const toast = useToast();
    const [upprCstmOrgzCd, setUpprCstmOrgzCd] = useState("");

    const form = {
        sctnInfo: useForm({
            defaultSchema: SF_SCTN_INFO,
        }),
    };

    const fetch = {
        createSctnInfo: useFetch({
            api: (data: any) => APIS.createSctnInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(`${URLS.ptli0918001q}?menuId=${menuId}`);
            },
            onError: (error: any) => {
                //에러 메시지 처리
                const { errorMessage } = error.response.data;
                modal.openModal({ content: errorMessage });
            },
        }),
    };

    const handler = {
        onListBtnClick: () => {
            navigate(`${URLS.ptli0918001q}?menuId=${menuId}`);
        },
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.sctnInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.sctnInfo.handleSubmit(
                () => {
                    const data = form.sctnInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.createSctnInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                    console.log(comnUtils.isEmpty(form.sctnInfo.errors), form.sctnInfo.isSubmitted);
                },
            )();
        },
        onChangeCstmOrgzCd: (val: any) => {
            setUpprCstmOrgzCd(val);
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.sctnInfo.schema.cstmOrgzCd}
                                onChange={(event) => handler.onChangeCstmOrgzCd(event.toUpperCase())}
                                value={upprCstmOrgzCd}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzNmTz} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzNmEn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.sctnInfo.schema.cstmOrgzNmKo} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Section></Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
